import {
  getWorkUnitByTokenRecursive,
  getWorkUnitByTokenService,
} from 'src/components/pages/sales/business-rule/helper/getWorkUnitByTokenRecursive'

export const getCurrentWorkUnitOnlyOne = async (
  work_unit_nodes,
  token_work_unit,
  setLoadingWorkUnits = null
) => {
  try {
    let work_unit = getWorkUnitByTokenRecursive(work_unit_nodes, token_work_unit)
    if (work_unit) {
      const mapper_work_unit = {
        ...work_unit,
        token: work_unit.value,
        long_name: work_unit.label,
      }
      return mapper_work_unit
    }
    setLoadingWorkUnits && setLoadingWorkUnits(true)
    work_unit = await getWorkUnitByTokenService(token_work_unit)
    setLoadingWorkUnits && setLoadingWorkUnits(false)
    if (work_unit) {
      return work_unit
    }
    return null
  } catch (error) {
    setLoadingWorkUnits && setLoadingWorkUnits(false)
  }
}
